import { Terms } from '@/api/terms.types.ts';
import useTermsQuery from '../../../queries/hooks/useTermsQuery';

export const useTermsList = (): Terms[] => {
  const { data } = useTermsQuery();

  return data.terms;
};
